import React from 'react';
import './style.scss';
import { Select, MenuItem, FormControl, InputLabel } from '@mui/material';

function TextInputDropdown({children, onChange, value,onclick, className, id, label, placeholder, style={}, error=false}) {

    let customStyle = style;
    let baseClass = 'TextInput';
    if (error){
        baseClass = 'TextInputError';
    }
    return (
        <FormControl variant="standard" className={`${baseClass} ${className}`} style={customStyle}>
            {label && <InputLabel id={`${id}-label`}>{label}</InputLabel>}
            <Select
                style={{color:'#AFAFAF'}}
                labelId={`${id}-label`}
                id={id}
                value={value}
                onChange={onChange}
                displayEmpty
                onClick={onclick}
                placeholder={placeholder}
            >
                {children}
            </Select>
        </FormControl>
    )
}

export default TextInputDropdown;
